// extracted by mini-css-extract-plugin
module.exports = {"Title":"news_Title__yVRK_","Item":"news_Item__7x_tI","News":"news_News__eKMeQ","Image":"news_Image__En9jQ","Name":"news_Name__W9S_w","Bottom":"news_Bottom__3kAbD"};